import { NgModule } from '@angular/core'
import { AsyncPipe, CommonModule } from '@angular/common'
import { GbSearchPipe } from './gb-search-pipe/gb-search.pipe'
import { GbCurrencySymbolPipe } from './gb-currency-symbol-pipe/gb-currency-symbol.pipe'
import { GbNumberMaskPipe } from './gb-number-mask-pipe/gb-number-mask.pipe'
import { GbOrderByPipe } from './gb-order-by-pipe/gb-order-by.pipe'
import { GbDisplayNamePipe } from './gb-display-name-pipe/gb-display-name.pipe'
import { GbSafePipe } from './gb-safe-pipe/gb-safe.pipe'
import { GbReplaceCharsPipe } from './gb-replace-chars-pipe/gb-replace-chars.pipe'
import { GbDateRangePipe } from './gb-date-range-pipe/gb-date-range.pipe'
import { GbGroupByPipe } from './gb-group-by-pipe/gb-group-by.pipe'

@NgModule({
  imports: [CommonModule],
  declarations: [
    GbCurrencySymbolPipe,
    GbSearchPipe,
    GbSafePipe,
    GbNumberMaskPipe,
    GbOrderByPipe,
    GbDisplayNamePipe,
    GbReplaceCharsPipe,
    GbDateRangePipe,
    GbGroupByPipe,
  ],
  exports: [
    GbCurrencySymbolPipe,
    GbSearchPipe,
    GbSafePipe,
    GbNumberMaskPipe,
    GbOrderByPipe,
    GbDisplayNamePipe,
    GbReplaceCharsPipe,
    GbDateRangePipe,
    GbGroupByPipe,
  ],
  providers: [AsyncPipe, GbCurrencySymbolPipe, GbSearchPipe, GbDisplayNamePipe],
})
export class SharedUtilsPipesModule {}
